// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"8d34aadc","160":"4be72b8d","195":"82923f9c","409":"901c6592","442":"d2d04468","499":"021cbbc4","666":"d00c6b3b","667":"419733be","787":"e582ec51"}[chunkId] + ".chunk.js";
};